import React from 'react';
import {Tooltip} from "@material-ui/core";
import {IconCircle} from './styles';


interface IRoundButtonProps {
    icon: any;
    color?: "red" | "green" | "orange" | "gray" | "default";
    tooltipTitle: string;
    onClick: (e?: any) => void;
}

const RoundButton = ({icon, color, tooltipTitle, onClick}: IRoundButtonProps) => {
    return (
        <Tooltip
            title={tooltipTitle}
            placement="top"
            onClick={() => onClick()}
        >
            <IconCircle size={"small"} color={color}>
                {icon}
            </IconCircle>
        </Tooltip>
    );
};

export default RoundButton;